import React, { useState, useEffect, useContext } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../Routes/AuthProvider"
import { AcceptApprovalRequest } from '../Services/ApprovalAPI';
import { RejectApprovalRequest } from '../Services/ApprovalAPI';

const FlightApprovalDetail = ({ approvalDetails }) => {

    const navigate = useNavigate();
    const { name, userName, roles } = useContext(AuthContext);
    const [remark, setRemark] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [selectedItem, setSelectedItem] = useState(null);

    // const booking = approvalDetails?.booking;
    // const bp = approvalDetails?.bookingPoints;
    // const fare = approvalDetails?.fares?.[0];
    const approval = approvalDetails?.requestedApprovals?.[0];


    const formatDate = (dateStr) => {
        if (!dateStr) return "-";

        const date = new Date(dateStr);

        if (isNaN(date)) return "-";

        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    // const SubmitAcceptApprovalRequest = (item) => {
    //     //console.log("Approved:", item);
    // };

    const SubmitAcceptApprovalRequest = async (item) => {
        if (!item) {
            alert("Invalid approval data");
            return;
        }
        //const { referenceNo, level1Approver, level1ApproverEmail, userId } = item;
        const { referenceNo, level1ApproverId, level1ApproverName, level1ApproverBy, level1ApproverEmail, level2ApproverId, level2ApproverName, level2ApproverBy, level2ApproverEmail, userId, product } = item;
        if (!referenceNo || !level1ApproverEmail) {
            alert("Missing required data");
            return;
        }
        setLoading(true);
        try {
            const requestBody = {
                referenceNo: referenceNo,
                level1ApproverEmail: level1ApproverEmail,
                level1ApproverType: level1ApproverId,
                level2ApproverEmail: level2ApproverEmail,
                level2ApproverType: level2ApproverId,
                product: "Flight",
                UserId: userName,
            };
            //console.log("requestBody:", requestBody);
            const data = await AcceptApprovalRequest(requestBody);
            if (data.message === "Booking Success" || data.message === "Booking Success") {
                if (data.productType === "Flight") {
                    navigate(`/thankyou?ReferenceNo=${referenceNo}`);
                } else {
                    navigate(`/bus/thankyou?ReferenceNo=${referenceNo}`);
                }
            } else {
                alert(data.message);
                navigate(`/approval`);
            }

            // //console.log("AcceptApprovalRequest:", data);
            // navigate(`/thankyou?ReferenceNo=${referenceNo}`);

        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    const SubmitRejectApprovalRequest = async (item) => {
        if (!item) {
            alert("Invalid approval data");
            return;
        }
        if (!remark) {
            alert("Remark Required");
            return;
        }

        const { referenceNo, level1ApproverId, level1ApproverName, level1ApproverBy, level1ApproverEmail, level2ApproverId, level2ApproverName, level2ApproverBy, level2ApproverEmail, userId, product } = item;
        if (!referenceNo || !level1ApproverEmail) {
            alert("Missing required data");
            return;
        }

        const modalElement = document.getElementById("myModal");
        const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
        modalInstance.hide();
        setLoading(true);
        try {

            const requestBody = {
                referenceNo: referenceNo,
                level1ApproverEmail: level1ApproverEmail,
                level1ApproverType: level1ApproverId,
                level2ApproverEmail: level2ApproverEmail,
                level2ApproverType: level2ApproverId,
                product: "Flight",
                UserId: userName,
                ApprovalRequestedByUserName: userId,
                ApprovalRequestedByEmail: "",
                remark: remark
            };
            //console.log("requestBody:", requestBody);
            const data = await RejectApprovalRequest(requestBody);
            alert(data.message);
            window.location.reload();
            setRemark("");
            setSelectedItem(null);
        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    const [timeLeft, setTimeLeft] = useState("");
    const getRemainingTime = (blockedOn) => {
        try {
            if (!blockedOn) return "Error";
            const blockTime = new Date(blockedOn);
            if (isNaN(blockTime)) return "Invalid Date";

            const expiryTime = new Date(blockTime.getTime() + 15 * 60000);

            const diff = expiryTime - new Date();

            if (diff <= 0) return "Expired";

            const m = Math.floor(diff / 60000);
            const s = Math.floor((diff % 60000) / 1000);

            return `${m}m ${s}s left`;
        } catch (error) {
            return "Error";
        }
    };

    const blockedOn = approvalDetails?.bookingStartTime;
    useEffect(() => {
        if (!blockedOn) {
            setTimeLeft("No Time");
            return;
        }
        setTimeLeft(getRemainingTime(blockedOn));
        const interval = setInterval(() => {
            setTimeLeft(getRemainingTime(blockedOn));
        }, 1000);
        return () => clearInterval(interval);
    }, [blockedOn]);

    const formatDateTime = (dateStr) => {
        if (!dateStr) return "-";

        const date = new Date(dateStr);

        if (isNaN(date.getTime())) return "-";

        return date
            .toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            })
            .replace(",", "")
            .replace("am", "AM")
            .replace("pm", "PM");
    };

    const getUserApprovalLevel = (approval, userName) => {
        const currentUserName = (userName || "").trim().toLowerCase();

        const level1Users = (approval.level1UserName || "")
            .split(";")
            .map(x => x.trim().toLowerCase())
            .filter(Boolean);

        const level2Users = (approval.level2UserName || "")
            .split(";")
            .map(x => x.trim().toLowerCase())
            .filter(Boolean);

        if (level1Users.includes(currentUserName)) {
            return 1;
        }

        if (level2Users.includes(currentUserName)) {
            return 2;
        }

        return 0;
    };

    return (
        <>
            <section className='wraper'>
                <div className='box_shadow mt-16'>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "10px 14px",
                            marginBottom: "15px",
                            borderRadius: "6px",
                            fontSize: "14px",
                            fontWeight: "500",
                            background: timeLeft === "Expired" ? "#f8d7da" : "#e7f3ff",
                            color: timeLeft === "Expired" ? "#842029" : "#084298",
                            borderLeft: `4px solid ${timeLeft === "Expired" ? "#dc3545" : "#0d6efd"}`,
                            zIndex: 10,
                            position: "relative"
                        }}
                    >
                        <span>⏳</span>
                        <span style={{ fontWeight: "600" }}>Booking Time:</span>
                        <span style={{ fontWeight: "700" }}>
                            {timeLeft === "Expired" ? "Session Expired" : timeLeft || "Calculating..."}
                        </span>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h4 className='headings'>Reason For Travel</h4>
                        </div>
                        <div className='col-md-6'>
                            <div class="d-flex mb-3">
                                <div class="labl">Trip ID </div>
                                <div class="labl_detls">{approvalDetails.requestedApprovals[0].referenceNo}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div class="d-flex mb-3">
                                <div class="labl">Travel Mode </div>
                                <div class="labl_detls">Business Travel</div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div class="d-flex mb-3">
                                <div class="labl">Employee ID </div>
                                <div class="labl_detls">{approvalDetails.requestedApprovals[0].employeeId}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div class="d-flex mb-3">
                                <div class="labl">Employee Name </div>
                                <div class="labl_detls">{approvalDetails.requestedApprovals[0].travellerName}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div class="d-flex mb-3">
                                <div class="labl">Biling Entity </div>
                                <div class="labl_detls">{approvalDetails?.corporateDetails?.companyName}</div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div class="d-flex mb-3">
                                <div class="labl">Selection Option</div>
                                <div class="labl_detls">{approvalDetails?.selectedOption}</div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h4 className='headings'>Travel Policy</h4>
                        </div>
                        <div className='col-md-6'>
                            <div class="d-flex mb-3">
                                <div class="labl">Policy Status </div>
                                <div
                                    className="labl_detls"
                                    style={{
                                        color: approvalDetails.airBookingResponse[0]?.policyStatus === "OutOfPolicy" ? "red" : "green",
                                        fontWeight: "600"
                                    }}
                                >
                                    {approvalDetails.airBookingResponse[0]?.policyStatus || "-"}
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div class="d-flex mb-3">
                                <div class="labl">Policy Reason </div>
                                <div className="labl_detls" style={{ color: "red" }}>{approvalDetails.airBookingResponse[0]?.policyReason || "-"}</div>
                            </div>
                        </div>
                    </div>

                    {/* Domestic OneWay */}
                    {approvalDetails && approvalDetails?.airBookingResponse?.[0] && approvalDetails?.airBookingResponse?.[0]?.trip === 1 && approvalDetails?.airBookingResponse?.[0]?.tripType === 1 && (
                        <>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <h4 className='headings'>Travel Info</h4>
                                </div>

                                {(() => {
                                    const flightDetails = approvalDetails?.airBookingResponse?.[0]?.flightDetails || [];

                                    const firstSegment = flightDetails[0];
                                    const lastSegment = flightDetails[flightDetails.length - 1];
                                    // const stops = segments.length > 0 ? segments.length - 1 : 0;
                                    return (
                                        <>
                                            <div className='col-md-6'>
                                                <div class="d-flex mb-3">
                                                    <div class="labl">From City </div>
                                                    <div class="labl_detls">{firstSegment?.departAirportName} ({firstSegment?.departAirportCode})</div>
                                                </div>
                                            </div>

                                            <div className='col-md-6'>
                                                <div class="d-flex mb-3">
                                                    <div class="labl">To City </div>
                                                    <div class="labl_detls">{lastSegment?.arrivalAirportName} ({lastSegment?.arrivalAirportCode})</div>
                                                </div>
                                            </div>
                                        </>
                                    );
                                })()}
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Date Of Travel </div>
                                        <div class="labl_detls">{
                                            new Date(
                                                approvalDetails.airBookingResponse[0].flightDetails[0].departDateTime
                                            ).toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric"
                                            })
                                        }</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Total Fare </div>
                                        <div class="labl_detls text-danger"><i className='fa fa-inr'></i> {(approvalDetails?.airBookingResponse?.[0]?.fareDetails?.totalFare || 0) + (approvalDetails?.airBookingResponse?.[1]?.fareDetails?.totalFare || 0)}</div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <h4 className="headings"> Selected Flight</h4>
                                    {approvalDetails?.airBookingResponse?.map((booking, i) => {
                                        const flightDetails = booking?.flightDetails || [];
                                        if (flightDetails.length === 0) return null;

                                        const firstSegment = flightDetails[0];
                                        const lastSegment = flightDetails[flightDetails.length - 1];

                                        const stop = flightDetails.length - 1;

                                        const flightNumber = flightDetails
                                            .map((seg) => `${seg.airLineCode}-${seg.flightNumber}`)
                                            .join(" / ");

                                        // Safe Date Parsing
                                        const departure = new Date(firstSegment?.departDateTime);
                                        const arrival = new Date(lastSegment?.arrivalDateTime);

                                        const formatTime = (date) =>
                                            isNaN(date)
                                                ? "--:--"
                                                : `${date.getHours().toString().padStart(2, "0")}:${date
                                                    .getMinutes()
                                                    .toString()
                                                    .padStart(2, "0")}`;

                                        const depTime = formatTime(departure);
                                        const arrTime = formatTime(arrival);

                                        // Better Duration (include layover OR show API duration)
                                        const diffMs = arrival - departure;
                                        const hours = Math.floor(diffMs / (1000 * 60 * 60));
                                        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                                        const duration = `${hours.toString().padStart(2, "0")}:${minutes
                                            .toString()
                                            .padStart(2, "0")}`;

                                        return (
                                            <div className="result_repeat mt-3 mb-3" key={i}>
                                                <div className="row">

                                                    {/* LEFT */}
                                                    <div className="col-md-8 col-lg-8">
                                                        <div className="row">

                                                            {/* Airline */}
                                                            <div className="col-md-4 col-lg-4">
                                                                <div className="row">
                                                                    <div className="col-md-4">
                                                                        <div className="flight_img">
                                                                            <img
                                                                                alt={firstSegment?.airLineName || "Flight"}
                                                                                width="50"
                                                                                src={`/assets/images/Flight_Images/${booking?.validatingCarrier}.gif`}
                                                                                onError={(e) =>
                                                                                (e.target.src =
                                                                                    "/assets/images/Flight_Images/default.gif")
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-8">
                                                                        <figure className="flight_sect">
                                                                            <span>{flightNumber}</span>
                                                                            <span className="airlineImage">
                                                                                {firstSegment?.airLineName || "--"}
                                                                            </span>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Timing */}
                                                            <div className="col-md-8 col-lg-8 border-left-right">
                                                                <div className="row">

                                                                    {/* Departure */}
                                                                    <div className="col-md-4">
                                                                        <div className="timer">
                                                                            <h4>{depTime}</h4>
                                                                            <p>{firstSegment?.departAirportCode}</p>
                                                                        </div>
                                                                    </div>

                                                                    {/* Duration */}
                                                                    <div className="col-md-3">
                                                                        <div className="deruation">
                                                                            <p>{duration}</p>
                                                                            <div className="bordr_top">
                                                                                <i className="fa fa-plane"></i>
                                                                            </div>
                                                                            <p className="stops">
                                                                                {stop === 0
                                                                                    ? "Non-stop"
                                                                                    : `${stop} Stop${stop > 1 ? "s" : ""}`}
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                    {/* Arrival */}
                                                                    <div className="col-md-4 offset-1">
                                                                        <div className="timer">
                                                                            <h4>{arrTime}</h4>
                                                                            <p>{lastSegment?.arrivalAirportCode}</p>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    {/* RIGHT - PRICE */}
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="price_view">
                                                            <div className="flight_char color">
                                                                <i className="fa fa-inr"></i>
                                                                {booking?.fareDetails?.totalFare ?? 0}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12 mt-5'>
                                    <h4 className="headings">
                                        AI Recommended |{" "}
                                        <span style={{ color: "green" }}>
                                            Save <i className="fa fa-inr"></i>{" "}
                                            {(
                                                ((approvalDetails?.airBookingResponse?.[0]?.fareDetails?.totalFare || 0) + (approvalDetails?.airBookingResponse?.[1]?.fareDetails?.totalFare || 0)) -
                                                ((approvalDetails?.recommendedOnwardFlight?.fares?.[0]?.totalFare || 0) + (approvalDetails?.recommendedReturnFlight?.fares?.[0]?.totalFare || 0))
                                            )}
                                        </span>
                                    </h4>
                                </div>
                                <div className='recomndRare'>
                                    {(() => {
                                        const flight = approvalDetails?.recommendedOnwardFlight;
                                        const segments = flight?.segments || [];
                                        if (!segments.length) return null;

                                        const firstSegment = segments[0];
                                        const lastSegment = segments[segments.length - 1];
                                        const stop = segments.length - 1;

                                        const flightNumber = segments
                                            .map((seg) => `${seg.airLineCode}-${seg.flightNumber}`)
                                            .join(" / ");

                                        const departure = new Date(firstSegment.departDateTime);
                                        const arrival = new Date(lastSegment.arrivalDateTime);

                                        const depTime = `${departure.getHours().toString().padStart(2, "0")}:${departure
                                            .getMinutes()
                                            .toString()
                                            .padStart(2, "0")}`;

                                        const arrTime = `${arrival.getHours().toString().padStart(2, "0")}:${arrival
                                            .getMinutes()
                                            .toString()
                                            .padStart(2, "0")}`;

                                        const diffMs = arrival - departure;
                                        const hours = Math.floor(diffMs / (1000 * 60 * 60));
                                        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                                        const duration = `${hours.toString().padStart(2, "0")}:${minutes
                                            .toString()
                                            .padStart(2, "0")}`;

                                        return (
                                            <div className="result_repeat AI-Recomnd mb-3">
                                                <div className="row">
                                                    <div className="col-md-8 col-lg-8">
                                                        <div className="row">
                                                            <div className="col-md-4 col-lg-4">
                                                                <div className="row">
                                                                    <div className="col-md-4 col-lg-4">
                                                                        <div className="flight_img">
                                                                            <img
                                                                                alt="flight"
                                                                                width="50"
                                                                                src={`/assets/images/Flight_Images/${flight?.validatingCarrier}.gif`}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-8 col-lg-8">
                                                                        <figure className="flight_sect">
                                                                            <span>{flightNumber}</span>
                                                                            <span className="airlineImage">
                                                                                {firstSegment.airLineName}
                                                                            </span>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-8 col-lg-8 border-left-right">
                                                                <div className="row">

                                                                    <div className="col-md-4 col-lg-4">
                                                                        <div className="timer">
                                                                            <h4>{depTime}</h4>
                                                                            <p>{firstSegment.departAirportCode}</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-3 col-lg-3">
                                                                        <div className="deruation">
                                                                            <p>{duration}</p>
                                                                            <div className="bordr_top">
                                                                                <i className="fa fa-plane"></i>
                                                                            </div>
                                                                            <p className="stops">{stop} stop</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4 col-lg-4 offset-1">
                                                                        <div className="timer">
                                                                            <h4>{arrTime}</h4>
                                                                            <p>{lastSegment.arrivalAirportCode}</p>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="price_view">
                                                            <div className="flight_char">
                                                                <i className="fa fa-inr"></i>
                                                                {flight?.fares?.[0].totalFare}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    })()}
                                </div>
                                {approvalDetails.recommendedReturnFlight && (
                                    <div className='recomndRare'>
                                        {(() => {
                                            const flight = approvalDetails?.recommendedReturnFlight;

                                            if (!flight) return null;

                                            const segments = flight?.segments || [];

                                            // ✅ IMPORTANT SAFETY
                                            if (!segments.length) return null;

                                            const firstSegment = segments[0];
                                            const lastSegment = segments[segments.length - 1];

                                            const stopsCount = segments.length - 1;

                                            const stopsText =
                                                stopsCount === 0
                                                    ? "Non-stop"
                                                    : stopsCount === 1
                                                        ? "1 Stop"
                                                        : `${stopsCount} Stops`;

                                            const flightNumber = segments
                                                .map((seg) => `${seg.airLineCode}-${seg.flightNumber}`)
                                                .join(" / ");

                                            const formatTime = (date) => {
                                                const d = new Date(date);
                                                return `${d.getHours().toString().padStart(2, "0")}:${d
                                                    .getMinutes()
                                                    .toString()
                                                    .padStart(2, "0")}`;
                                            };

                                            return (
                                                <div className="result_repeat AI-Recomnd mb-3">
                                                    <div className="row">
                                                        <div className="col-md-8 col-lg-8">
                                                            <div className="row">
                                                                <div className="col-md-4 col-lg-4">
                                                                    <div className="row">
                                                                        <div className="col-md-4 col-lg-4">
                                                                            <div className="flight_img">
                                                                                <img
                                                                                    alt="flight"
                                                                                    width="50"
                                                                                    src={`/assets/images/Flight_Images/${flight?.validatingCarrier}.gif`}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-8 col-lg-8">
                                                                            <figure className="flight_sect">
                                                                                <span>{flightNumber}</span>
                                                                                <span className="airlineImage">
                                                                                    {firstSegment?.airLineName}
                                                                                </span>
                                                                            </figure>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-8 col-lg-8 border-left-right">
                                                                    <div className="row">
                                                                        <div className="col-md-4 col-lg-4">
                                                                            <div className="timer">
                                                                                <h4>{formatTime(firstSegment.departDateTime)}</h4>
                                                                                <p>{firstSegment.departAirportCode}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-3 col-lg-3">
                                                                            <div className="deruation">
                                                                                <p>{flight?.totalDuration}</p>
                                                                                <div className="bordr_top">
                                                                                    <i className="fa fa-plane"></i>
                                                                                </div>
                                                                                <p className="stops">{stopsText}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-4 col-lg-4 offset-1">
                                                                            <div className="timer">
                                                                                <h4>{formatTime(lastSegment.arrivalDateTime)}</h4>
                                                                                <p>{lastSegment.arrivalAirportCode}</p>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-lg-4">
                                                            <div className="price_view">
                                                                <div className="flight_char">
                                                                    <i className="fa fa-inr"></i>
                                                                    {/* {flight?.fareDetails?.totalFare} */}
                                                                    {flight?.fares?.[0].totalFare}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            );
                                        })()}
                                    </div>
                                )}
                            </div>
                        </>
                    )}

                    {/* Domestic Round Trip */}
                    {approvalDetails && approvalDetails?.airBookingResponse?.[0] && approvalDetails?.airBookingResponse?.[0]?.trip === 1 && approvalDetails?.airBookingResponse?.[0]?.tripType === 2 && (
                        <>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <h4 className='headings'>Travel Info</h4>
                                </div>

                                {(() => {
                                    const flightDetails = approvalDetails?.airBookingResponse?.[0]?.flightDetails || [];

                                    const firstSegment = flightDetails[0];
                                    const lastSegment = flightDetails[flightDetails.length - 1];
                                    // const stops = segments.length > 0 ? segments.length - 1 : 0;
                                    return (
                                        <>
                                            <div className='col-md-6'>
                                                <div class="d-flex mb-3">
                                                    <div class="labl">From City </div>
                                                    <div class="labl_detls">{firstSegment?.departAirportName} ({firstSegment?.departAirportCode})</div>
                                                </div>
                                            </div>

                                            <div className='col-md-6'>
                                                <div class="d-flex mb-3">
                                                    <div class="labl">To City </div>
                                                    <div class="labl_detls">{lastSegment?.arrivalAirportName} ({lastSegment?.arrivalAirportCode})</div>
                                                </div>
                                            </div>
                                        </>
                                    );
                                })()}
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Date Of Travel </div>
                                        <div class="labl_detls">{
                                            new Date(
                                                approvalDetails.airBookingResponse[0].flightDetails[0].departDateTime
                                            ).toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric"
                                            })
                                        }</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Total Fare </div>
                                        <div class="labl_detls text-danger"><i className='fa fa-inr'></i> {(approvalDetails?.airBookingResponse?.[0]?.fareDetails?.totalFare || 0) + (approvalDetails?.airBookingResponse?.[1]?.fareDetails?.totalFare || 0)}</div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <h4 className="headings"> Selected Flight</h4>                                    {approvalDetails?.airBookingResponse?.map((booking, i) => {
                                        const flightDetails = booking?.flightDetails || [];
                                        if (flightDetails.length === 0) return null;

                                        const firstSegment = flightDetails[0];
                                        const lastSegment = flightDetails[flightDetails.length - 1];

                                        const stop = flightDetails.length - 1;

                                        const flightNumber = flightDetails
                                            .map((seg) => `${seg.airLineCode}-${seg.flightNumber}`)
                                            .join(" / ");

                                        // Safe Date Parsing
                                        const departure = new Date(firstSegment?.departDateTime);
                                        const arrival = new Date(lastSegment?.arrivalDateTime);

                                        const formatTime = (date) =>
                                            isNaN(date)
                                                ? "--:--"
                                                : `${date.getHours().toString().padStart(2, "0")}:${date
                                                    .getMinutes()
                                                    .toString()
                                                    .padStart(2, "0")}`;

                                        const depTime = formatTime(departure);
                                        const arrTime = formatTime(arrival);

                                        // Better Duration (include layover OR show API duration)
                                        const diffMs = arrival - departure;
                                        const hours = Math.floor(diffMs / (1000 * 60 * 60));
                                        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                                        const duration = `${hours.toString().padStart(2, "0")}:${minutes
                                            .toString()
                                            .padStart(2, "0")}`;

                                        return (
                                            <div className="result_repeat mt-3 mb-3" key={i}>
                                                <div className="row">

                                                    {/* LEFT */}
                                                    <div className="col-md-8 col-lg-8">
                                                        <div className="row">

                                                            {/* Airline */}
                                                            <div className="col-md-4 col-lg-4">
                                                                <div className="row">
                                                                    <div className="col-md-4">
                                                                        <div className="flight_img">
                                                                            <img
                                                                                alt={firstSegment?.airLineName || "Flight"}
                                                                                width="50"
                                                                                src={`/assets/images/Flight_Images/${booking?.validatingCarrier}.gif`}
                                                                                onError={(e) =>
                                                                                (e.target.src =
                                                                                    "/assets/images/Flight_Images/default.gif")
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-8">
                                                                        <figure className="flight_sect">
                                                                            <span>{flightNumber}</span>
                                                                            <span className="airlineImage">
                                                                                {firstSegment?.airLineName || "--"}
                                                                            </span>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Timing */}
                                                            <div className="col-md-8 col-lg-8 border-left-right">
                                                                <div className="row">

                                                                    {/* Departure */}
                                                                    <div className="col-md-4">
                                                                        <div className="timer">
                                                                            <h4>{depTime}</h4>
                                                                            <p>{firstSegment?.departAirportCode}</p>
                                                                        </div>
                                                                    </div>

                                                                    {/* Duration */}
                                                                    <div className="col-md-3">
                                                                        <div className="deruation">
                                                                            <p>{duration}</p>
                                                                            <div className="bordr_top">
                                                                                <i className="fa fa-plane"></i>
                                                                            </div>
                                                                            <p className="stops">
                                                                                {stop === 0
                                                                                    ? "Non-stop"
                                                                                    : `${stop} Stop${stop > 1 ? "s" : ""}`}
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                    {/* Arrival */}
                                                                    <div className="col-md-4 offset-1">
                                                                        <div className="timer">
                                                                            <h4>{arrTime}</h4>
                                                                            <p>{lastSegment?.arrivalAirportCode}</p>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    {/* RIGHT - PRICE */}
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="price_view">
                                                            <div className="flight_char color">
                                                                <i className="fa fa-inr"></i>
                                                                {booking?.fareDetails?.totalFare ?? 0}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12 mt-5'>
                                    <h4 className="headings">
                                        AI Recommended |{" "}
                                        <span style={{ color: "green" }}>
                                            Save <i className="fa fa-inr"></i>{" "}
                                            {(
                                                ((approvalDetails?.airBookingResponse?.[0]?.fareDetails?.totalFare || 0) + (approvalDetails?.airBookingResponse?.[1]?.fareDetails?.totalFare || 0)) -
                                                ((approvalDetails?.recommendedOnwardFlight?.fares?.[0]?.totalFare || 0) + (approvalDetails?.recommendedReturnFlight?.fares?.[0]?.totalFare || 0))
                                            )}
                                        </span>
                                    </h4>
                                </div>
                                <div className='recomndRare'>
                                    {(() => {
                                        const flight = approvalDetails?.recommendedOnwardFlight;
                                        const segments = flight?.segments || [];
                                        if (!segments.length) return null;

                                        const firstSegment = segments[0];
                                        const lastSegment = segments[segments.length - 1];
                                        const stop = segments.length - 1;

                                        const flightNumber = segments
                                            .map((seg) => `${seg.airLineCode}-${seg.flightNumber}`)
                                            .join(" / ");

                                        const departure = new Date(firstSegment.departDateTime);
                                        const arrival = new Date(lastSegment.arrivalDateTime);

                                        const depTime = `${departure.getHours().toString().padStart(2, "0")}:${departure
                                            .getMinutes()
                                            .toString()
                                            .padStart(2, "0")}`;

                                        const arrTime = `${arrival.getHours().toString().padStart(2, "0")}:${arrival
                                            .getMinutes()
                                            .toString()
                                            .padStart(2, "0")}`;

                                        const diffMs = arrival - departure;
                                        const hours = Math.floor(diffMs / (1000 * 60 * 60));
                                        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                                        const duration = `${hours.toString().padStart(2, "0")}:${minutes
                                            .toString()
                                            .padStart(2, "0")}`;

                                        return (
                                            <div className="result_repeat AI-Recomnd mb-3">
                                                <div className="row">
                                                    <div className="col-md-8 col-lg-8">
                                                        <div className="row">
                                                            <div className="col-md-4 col-lg-4">
                                                                <div className="row">
                                                                    <div className="col-md-4 col-lg-4">
                                                                        <div className="flight_img">
                                                                            <img
                                                                                alt="flight"
                                                                                width="50"
                                                                                src={`/assets/images/Flight_Images/${flight?.validatingCarrier}.gif`}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-8 col-lg-8">
                                                                        <figure className="flight_sect">
                                                                            <span>{flightNumber}</span>
                                                                            <span className="airlineImage">
                                                                                {firstSegment.airLineName}
                                                                            </span>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-8 col-lg-8 border-left-right">
                                                                <div className="row">

                                                                    <div className="col-md-4 col-lg-4">
                                                                        <div className="timer">
                                                                            <h4>{depTime}</h4>
                                                                            <p>{firstSegment.departAirportCode}</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-3 col-lg-3">
                                                                        <div className="deruation">
                                                                            <p>{duration}</p>
                                                                            <div className="bordr_top">
                                                                                <i className="fa fa-plane"></i>
                                                                            </div>
                                                                            <p className="stops">{stop} stop</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4 col-lg-4 offset-1">
                                                                        <div className="timer">
                                                                            <h4>{arrTime}</h4>
                                                                            <p>{lastSegment.arrivalAirportCode}</p>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="price_view">
                                                            <div className="flight_char">
                                                                <i className="fa fa-inr"></i>
                                                                {flight?.fares?.[0].totalFare}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    })()}
                                </div>
                                {approvalDetails.recommendedReturnFlight && (
                                    <div className='recomndRare'>
                                        {(() => {
                                            const flight = approvalDetails?.recommendedReturnFlight;

                                            if (!flight) return null;

                                            const segments = flight?.segments || [];

                                            // ✅ IMPORTANT SAFETY
                                            if (!segments.length) return null;

                                            const firstSegment = segments[0];
                                            const lastSegment = segments[segments.length - 1];

                                            const stopsCount = segments.length - 1;

                                            const stopsText =
                                                stopsCount === 0
                                                    ? "Non-stop"
                                                    : stopsCount === 1
                                                        ? "1 Stop"
                                                        : `${stopsCount} Stops`;

                                            const flightNumber = segments
                                                .map((seg) => `${seg.airLineCode}-${seg.flightNumber}`)
                                                .join(" / ");

                                            const formatTime = (date) => {
                                                const d = new Date(date);
                                                return `${d.getHours().toString().padStart(2, "0")}:${d
                                                    .getMinutes()
                                                    .toString()
                                                    .padStart(2, "0")}`;
                                            };

                                            return (
                                                <div className="result_repeat AI-Recomnd mb-3">
                                                    <div className="row">
                                                        <div className="col-md-8 col-lg-8">
                                                            <div className="row">
                                                                <div className="col-md-4 col-lg-4">
                                                                    <div className="row">
                                                                        <div className="col-md-4 col-lg-4">
                                                                            <div className="flight_img">
                                                                                <img
                                                                                    alt="flight"
                                                                                    width="50"
                                                                                    src={`/assets/images/Flight_Images/${flight?.validatingCarrier}.gif`}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-8 col-lg-8">
                                                                            <figure className="flight_sect">
                                                                                <span>{flightNumber}</span>
                                                                                <span className="airlineImage">
                                                                                    {firstSegment?.airLineName}
                                                                                </span>
                                                                            </figure>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-8 col-lg-8 border-left-right">
                                                                    <div className="row">
                                                                        <div className="col-md-4 col-lg-4">
                                                                            <div className="timer">
                                                                                <h4>{formatTime(firstSegment.departDateTime)}</h4>
                                                                                <p>{firstSegment.departAirportCode}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-3 col-lg-3">
                                                                            <div className="deruation">
                                                                                <p>{flight?.totalDuration}</p>
                                                                                <div className="bordr_top">
                                                                                    <i className="fa fa-plane"></i>
                                                                                </div>
                                                                                <p className="stops">{stopsText}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-4 col-lg-4 offset-1">
                                                                            <div className="timer">
                                                                                <h4>{formatTime(lastSegment.arrivalDateTime)}</h4>
                                                                                <p>{lastSegment.arrivalAirportCode}</p>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-lg-4">
                                                            <div className="price_view">
                                                                <div className="flight_char">
                                                                    <i className="fa fa-inr"></i>
                                                                    {/* {flight?.fareDetails?.totalFare} */}
                                                                    {flight?.fares?.[0].totalFare}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            );
                                        })()}
                                    </div>
                                )}
                            </div>
                        </>
                    )}


                    {/* Internation roundTrip */}
                    {approvalDetails &&
                        approvalDetails?.airBookingResponse?.length > 0 &&
                        approvalDetails?.airBookingResponse?.[0]?.trip === 2 &&
                        approvalDetails?.airBookingResponse?.[0]?.tripType === 2 && (
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h4 className="headings">Travel Info</h4>
                                    </div>

                                    {(() => {
                                        const allFlights = approvalDetails?.airBookingResponse?.[0]?.flightDetails || [];

                                        // ✅ GROUP BY flightCount (IMPORTANT FIX)
                                        const groupedFlights = allFlights.reduce((acc, flight) => {
                                            const key = flight.flightCount;
                                            if (!acc[key]) acc[key] = [];
                                            acc[key].push(flight);
                                            return acc;
                                        }, {});

                                        const journeys = Object.values(groupedFlights);

                                        return (
                                            <>
                                                {/* TOP SUMMARY */}
                                                <div className="col-md-6">
                                                    <div className="d-flex mb-3">
                                                        <div className="labl">From City </div>
                                                        <div className="labl_detls">
                                                            {journeys[0]?.[0]?.departAirportName} ({journeys[0]?.[0]?.departAirportCode})
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="d-flex mb-3">
                                                        <div className="labl">To City </div>
                                                        <div className="labl_detls">
                                                            {
                                                                journeys[0]?.[journeys[0].length - 1]?.arrivalAirportName
                                                            } ({journeys[0]?.[journeys[0].length - 1]?.arrivalAirportCode})
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* DATE */}
                                                <div className="col-md-6">
                                                    <div className="d-flex mb-3">
                                                        <div className="labl">Date Of Travel </div>
                                                        <div className="labl_detls">
                                                            {new Date(journeys[0]?.[0]?.departDateTime).toLocaleDateString("en-GB", {
                                                                day: "2-digit",
                                                                month: "short",
                                                                year: "numeric",
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className="d-flex mb-3">
                                                        <div className="labl">Total Fare </div>
                                                        <div className="labl_detls text-danger">
                                                            <i className='fa fa-inr'></i>
                                                            {approvalDetails?.airBookingResponse?.[0]?.fareDetails?.totalFare}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* FLIGHT LIST */}
                                                <div className="col-md-12">
                                                    <h4 className="headings"> Selected Flight | <i className='fa fa-inr'></i> {approvalDetails?.airBookingResponse?.[0]?.fareDetails?.totalFare}  </h4>
                                                    {journeys.map((flightDetails, i) => {
                                                        if (flightDetails.length === 0) return null;

                                                        const firstSegment = flightDetails[0];
                                                        const lastSegment = flightDetails[flightDetails.length - 1];

                                                        const stop = flightDetails.length - 1;

                                                        const flightNumber = flightDetails
                                                            .map((seg) => `${seg.airLineCode}-${seg.flightNumber}`)
                                                            .join(" / ");

                                                        const departure = new Date(firstSegment.departDateTime);
                                                        const arrival = new Date(lastSegment.arrivalDateTime);

                                                        const formatTime = (date) =>
                                                            isNaN(date)
                                                                ? "--:--"
                                                                : `${date.getHours().toString().padStart(2, "0")}:${date
                                                                    .getMinutes()
                                                                    .toString()
                                                                    .padStart(2, "0")}`;

                                                        const depTime = formatTime(departure);
                                                        const arrTime = formatTime(arrival);

                                                        const diffMs = arrival - departure;
                                                        const hours = Math.floor(diffMs / (1000 * 60 * 60));
                                                        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                                                        const duration = `${hours.toString().padStart(2, "0")}:${minutes
                                                            .toString()
                                                            .padStart(2, "0")}`;

                                                        return (
                                                            <div className="result_repeat mt-3 mb-3" key={i}>
                                                                <div className="row">

                                                                    {/* LEFT */}
                                                                    <div className="col-md-8">
                                                                        <div className="row">

                                                                            {/* Airline */}
                                                                            <div className="col-md-4">
                                                                                <div className="row">
                                                                                    <div className="col-md-4">
                                                                                        <img
                                                                                            width="50"
                                                                                            src={`/assets/images/Flight_Images/${firstSegment.airLineCode}.gif`}
                                                                                            onError={(e) =>
                                                                                            (e.target.src =
                                                                                                "/assets/images/Flight_Images/default.gif")
                                                                                            }
                                                                                        />
                                                                                    </div>

                                                                                    <div className="col-md-8">
                                                                                        <span>{flightNumber}</span>
                                                                                        <br />
                                                                                        <span>{firstSegment.airLineName}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Timing */}
                                                                            <div className="col-md-8 border-left-right">
                                                                                <div className="row">

                                                                                    {/* Departure */}
                                                                                    <div className="col-md-4">
                                                                                        <h4>{depTime}</h4>
                                                                                        <p>{firstSegment.departAirportCode}</p>
                                                                                    </div>

                                                                                    {/* Duration */}
                                                                                    <div className="col-md-3">
                                                                                        <div className="deruation">
                                                                                            <p>{duration}</p>
                                                                                            <div className="bordr_top">
                                                                                                <i className="fa fa-plane"></i>
                                                                                            </div>
                                                                                            <p>
                                                                                                {stop === 0
                                                                                                    ? "Non-stop"
                                                                                                    : `${stop} Stop${stop > 1 ? "s" : ""}`}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Arrival */}
                                                                                    <div className="col-md-4 offset-1">
                                                                                        <h4>{arrTime}</h4>
                                                                                        <p>{lastSegment.arrivalAirportCode}</p>
                                                                                    </div>

                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                    {/* RIGHT */}
                                                                    <div className="col-md-4">
                                                                        <div className="price_view">
                                                                            <div className="flight_char color">
                                                                                <i className="fa fa-plane"></i> {i === 0 ? "Onward" : "Return"}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </>
                                        );
                                    })()}
                                </div>

                                {/* ================= AI RECOMMENDED ================= */}

                                <div className='row'>
                                    <div className='col-md-12 mt-5'>
                                        <h4 className="headings">
                                            AI Recommended | <i className='fa fa-inr'></i> {approvalDetails?.recommendedOnwardFlight?.fares?.[0]?.totalFare} |{" "}
                                            <span style={{ color: "green" }}>
                                                Save <i className="fa fa-inr"></i>{" "}
                                                {(
                                                    (approvalDetails?.airBookingResponse?.[0]?.fareDetails?.totalFare || 0) -
                                                    (approvalDetails?.recommendedOnwardFlight?.fares?.[0]?.totalFare || 0)
                                                )}
                                            </span>
                                        </h4>
                                    </div>

                                    {(() => {
                                        const flight = approvalDetails?.recommendedOnwardFlight;
                                        const segments = flight?.segments || [];

                                        if (!segments.length) return null;

                                        const grouped = segments.reduce((acc, seg) => {
                                            const key = seg.flightCount;
                                            if (!acc[key]) acc[key] = [];
                                            acc[key].push(seg);
                                            return acc;
                                        }, {});

                                        const journeys = Object.values(grouped);

                                        const formatTime = (date) => {
                                            const d = new Date(date);
                                            return `${d.getHours().toString().padStart(2, "0")}:${d
                                                .getMinutes()
                                                .toString()
                                                .padStart(2, "0")}`;
                                        };

                                        return (
                                            <>
                                                {journeys.map((segments, i) => {
                                                    const first = segments[0];
                                                    const last = segments[segments.length - 1];

                                                    const stops = segments.length - 1;

                                                    const stopsText =
                                                        stops === 0 ? "Non-stop" : stops === 1 ? "1 Stop" : `${stops} Stops`;

                                                    const flightNumber = segments
                                                        .map((s) => `${s.airLineCode}-${s.flightNumber}`)
                                                        .join(" / ");

                                                    const departure = new Date(first.departDateTime);
                                                    const arrival = new Date(last.arrivalDateTime);

                                                    const diffMs = arrival - departure;
                                                    const hours = Math.floor(diffMs / (1000 * 60 * 60));
                                                    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                                                    const duration = `${hours.toString().padStart(2, "0")}:${minutes
                                                        .toString()
                                                        .padStart(2, "0")}`;

                                                    const label = i === 0 ? "Onward" : i === 1 ? "Return" : `Trip ${i + 1}`;

                                                    return (
                                                        <div className="recomndRare" key={i}>
                                                            <div className="result_repeat AI-Recomnd mb-3">
                                                                <div className="row">

                                                                    {/* LEFT */}
                                                                    <div className="col-md-8">
                                                                        <div className="row">

                                                                            {/* Airline */}
                                                                            <div className="col-md-4">
                                                                                <div className="row">
                                                                                    <div className="col-md-4">
                                                                                        <img
                                                                                            width="50"
                                                                                            src={`/assets/images/Flight_Images/${first.airLineCode}.gif`}
                                                                                            onError={(e) =>
                                                                                            (e.target.src =
                                                                                                "/assets/images/Flight_Images/default.gif")
                                                                                            }
                                                                                        />
                                                                                    </div>

                                                                                    <div className="col-md-8">
                                                                                        <span>{flightNumber}</span>
                                                                                        <br />
                                                                                        <span>{first.airLineName}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Timing */}
                                                                            <div className="col-md-8 border-left-right">
                                                                                <div className="row">

                                                                                    {/* Departure */}
                                                                                    <div className="col-md-4">
                                                                                        <div className="timer">
                                                                                            <h4>{formatTime(first.departDateTime)}</h4>
                                                                                            <p>{first.departAirportCode}</p>
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Duration */}
                                                                                    <div className="col-md-3">
                                                                                        <div className="deruation">
                                                                                            <p>{duration}</p>
                                                                                            <div className="bordr_top">
                                                                                                <i className="fa fa-plane"></i>
                                                                                            </div>
                                                                                            <p className="stops">{stopsText}</p>
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Arrival */}
                                                                                    <div className="col-md-4 offset-1">
                                                                                        <div className="timer">
                                                                                            <h4>{formatTime(last.arrivalDateTime)}</h4>
                                                                                            <p>{last.arrivalAirportCode}</p>
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                    {/* RIGHT */}
                                                                    <div className="col-md-4">
                                                                        <div className="price_view">
                                                                            <div
                                                                                className="flight_char"

                                                                            >
                                                                                <i className="fa fa-plane"></i> {label}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        );
                                    })()}
                                </div>
                            </>
                        )}

                    {/* Internation OneWay */}
                    {approvalDetails &&
                        approvalDetails?.airBookingResponse?.length > 0 &&
                        approvalDetails?.airBookingResponse?.[0]?.trip === 2 &&
                        approvalDetails?.airBookingResponse?.[0]?.tripType === 1 && (
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h4 className="headings">Travel Info</h4>
                                    </div>

                                    {(() => {
                                        const allFlights = approvalDetails?.airBookingResponse?.[0]?.flightDetails || [];

                                        // ✅ GROUP BY flightCount (IMPORTANT FIX)
                                        const groupedFlights = allFlights.reduce((acc, flight) => {
                                            const key = flight.flightCount;
                                            if (!acc[key]) acc[key] = [];
                                            acc[key].push(flight);
                                            return acc;
                                        }, {});

                                        const journeys = Object.values(groupedFlights);

                                        return (
                                            <>
                                                {/* TOP SUMMARY */}
                                                <div className="col-md-6">
                                                    <div className="d-flex mb-3">
                                                        <div className="labl">From City </div>
                                                        <div className="labl_detls">
                                                            {journeys[0]?.[0]?.departAirportName} ({journeys[0]?.[0]?.departAirportCode})
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="d-flex mb-3">
                                                        <div className="labl">To City </div>
                                                        <div className="labl_detls">
                                                            {
                                                                journeys[0]?.[journeys[0].length - 1]?.arrivalAirportName
                                                            } ({journeys[0]?.[journeys[0].length - 1]?.arrivalAirportCode})
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* DATE */}
                                                <div className="col-md-6">
                                                    <div className="d-flex mb-3">
                                                        <div className="labl">Date Of Travel </div>
                                                        <div className="labl_detls">
                                                            {new Date(journeys[0]?.[0]?.departDateTime).toLocaleDateString("en-GB", {
                                                                day: "2-digit",
                                                                month: "short",
                                                                year: "numeric",
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className="d-flex mb-3">
                                                        <div className="labl">Total Fare </div>
                                                        <div className="labl_detls text-danger">
                                                            <i className='fa fa-inr'></i>
                                                            {approvalDetails?.airBookingResponse?.[0]?.fareDetails?.totalFare}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* FLIGHT LIST */}
                                                <div className="col-md-12">
                                                    <h4 className="headings"> Selected Flight | <i className='fa fa-inr'></i> {approvalDetails?.airBookingResponse?.[0]?.fareDetails?.totalFare}  </h4>
                                                    {journeys.map((flightDetails, i) => {
                                                        if (flightDetails.length === 0) return null;

                                                        const firstSegment = flightDetails[0];
                                                        const lastSegment = flightDetails[flightDetails.length - 1];

                                                        const stop = flightDetails.length - 1;

                                                        const flightNumber = flightDetails
                                                            .map((seg) => `${seg.airLineCode}-${seg.flightNumber}`)
                                                            .join(" / ");

                                                        const departure = new Date(firstSegment.departDateTime);
                                                        const arrival = new Date(lastSegment.arrivalDateTime);

                                                        const formatTime = (date) =>
                                                            isNaN(date)
                                                                ? "--:--"
                                                                : `${date.getHours().toString().padStart(2, "0")}:${date
                                                                    .getMinutes()
                                                                    .toString()
                                                                    .padStart(2, "0")}`;

                                                        const depTime = formatTime(departure);
                                                        const arrTime = formatTime(arrival);

                                                        const diffMs = arrival - departure;
                                                        const hours = Math.floor(diffMs / (1000 * 60 * 60));
                                                        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                                                        const duration = `${hours.toString().padStart(2, "0")}:${minutes
                                                            .toString()
                                                            .padStart(2, "0")}`;

                                                        return (
                                                            <div className="result_repeat mt-3 mb-3" key={i}>
                                                                <div className="row">

                                                                    {/* LEFT */}
                                                                    <div className="col-md-8">
                                                                        <div className="row">

                                                                            {/* Airline */}
                                                                            <div className="col-md-4">
                                                                                <div className="row">
                                                                                    <div className="col-md-4">
                                                                                        <img
                                                                                            width="50"
                                                                                            src={`/assets/images/Flight_Images/${firstSegment.airLineCode}.gif`}
                                                                                            onError={(e) =>
                                                                                            (e.target.src =
                                                                                                "/assets/images/Flight_Images/default.gif")
                                                                                            }
                                                                                        />
                                                                                    </div>

                                                                                    <div className="col-md-8">
                                                                                        <span>{flightNumber}</span>
                                                                                        <br />
                                                                                        <span>{firstSegment.airLineName}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Timing */}
                                                                            <div className="col-md-8 border-left-right">
                                                                                <div className="row">

                                                                                    {/* Departure */}
                                                                                    <div className="col-md-4">
                                                                                        <h4>{depTime}</h4>
                                                                                        <p>{firstSegment.departAirportCode}</p>
                                                                                    </div>

                                                                                    {/* Duration */}
                                                                                    <div className="col-md-3">
                                                                                        <div className="deruation">
                                                                                            <p>{duration}</p>
                                                                                            <div className="bordr_top">
                                                                                                <i className="fa fa-plane"></i>
                                                                                            </div>
                                                                                            <p>
                                                                                                {stop === 0
                                                                                                    ? "Non-stop"
                                                                                                    : `${stop} Stop${stop > 1 ? "s" : ""}`}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Arrival */}
                                                                                    <div className="col-md-4 offset-1">
                                                                                        <h4>{arrTime}</h4>
                                                                                        <p>{lastSegment.arrivalAirportCode}</p>
                                                                                    </div>

                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                    {/* RIGHT */}
                                                                    <div className="col-md-4">
                                                                        <div className="price_view">
                                                                            <div className="flight_char color">
                                                                                <i className="fa fa-plane"></i> {i === 0 ? "Onward" : "Return"}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </>
                                        );
                                    })()}
                                </div>

                                {/* ================= AI RECOMMENDED ================= */}

                                <div className='row'>
                                    <div className='col-md-12 mt-5'>
                                        <h4 className="headings">
                                            AI Recommended | <i className='fa fa-inr'></i> {approvalDetails?.recommendedOnwardFlight?.fares?.[0]?.totalFare} |{" "}
                                            <span style={{ color: "green" }}>
                                                Save <i className="fa fa-inr"></i>{" "}
                                                {(
                                                    (approvalDetails?.airBookingResponse?.[0]?.fareDetails?.totalFare || 0) -
                                                    (approvalDetails?.recommendedOnwardFlight?.fares?.[0]?.totalFare || 0)
                                                )}
                                            </span>
                                        </h4>
                                    </div>

                                    {(() => {
                                        const flight = approvalDetails?.recommendedOnwardFlight;
                                        const segments = flight?.segments || [];

                                        if (!segments.length) return null;

                                        const grouped = segments.reduce((acc, seg) => {
                                            const key = seg.flightCount;
                                            if (!acc[key]) acc[key] = [];
                                            acc[key].push(seg);
                                            return acc;
                                        }, {});

                                        const journeys = Object.values(grouped);

                                        const formatTime = (date) => {
                                            const d = new Date(date);
                                            return `${d.getHours().toString().padStart(2, "0")}:${d
                                                .getMinutes()
                                                .toString()
                                                .padStart(2, "0")}`;
                                        };

                                        return (
                                            <>
                                                {journeys.map((segments, i) => {
                                                    const first = segments[0];
                                                    const last = segments[segments.length - 1];

                                                    const stops = segments.length - 1;

                                                    const stopsText =
                                                        stops === 0 ? "Non-stop" : stops === 1 ? "1 Stop" : `${stops} Stops`;

                                                    const flightNumber = segments
                                                        .map((s) => `${s.airLineCode}-${s.flightNumber}`)
                                                        .join(" / ");

                                                    const departure = new Date(first.departDateTime);
                                                    const arrival = new Date(last.arrivalDateTime);

                                                    const diffMs = arrival - departure;
                                                    const hours = Math.floor(diffMs / (1000 * 60 * 60));
                                                    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                                                    const duration = `${hours.toString().padStart(2, "0")}:${minutes
                                                        .toString()
                                                        .padStart(2, "0")}`;

                                                    const label = i === 0 ? "Onward" : i === 1 ? "Return" : `Trip ${i + 1}`;

                                                    return (
                                                        <div className="recomndRare" key={i}>
                                                            <div className="result_repeat AI-Recomnd mb-3">
                                                                <div className="row">

                                                                    {/* LEFT */}
                                                                    <div className="col-md-8">
                                                                        <div className="row">

                                                                            {/* Airline */}
                                                                            <div className="col-md-4">
                                                                                <div className="row">
                                                                                    <div className="col-md-4">
                                                                                        <img
                                                                                            width="50"
                                                                                            src={`/assets/images/Flight_Images/${first.airLineCode}.gif`}
                                                                                            onError={(e) =>
                                                                                            (e.target.src =
                                                                                                "/assets/images/Flight_Images/default.gif")
                                                                                            }
                                                                                        />
                                                                                    </div>

                                                                                    <div className="col-md-8">
                                                                                        <span>{flightNumber}</span>
                                                                                        <br />
                                                                                        <span>{first.airLineName}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Timing */}
                                                                            <div className="col-md-8 border-left-right">
                                                                                <div className="row">

                                                                                    {/* Departure */}
                                                                                    <div className="col-md-4">
                                                                                        <div className="timer">
                                                                                            <h4>{formatTime(first.departDateTime)}</h4>
                                                                                            <p>{first.departAirportCode}</p>
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Duration */}
                                                                                    <div className="col-md-3">
                                                                                        <div className="deruation">
                                                                                            <p>{duration}</p>
                                                                                            <div className="bordr_top">
                                                                                                <i className="fa fa-plane"></i>
                                                                                            </div>
                                                                                            <p className="stops">{stopsText}</p>
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Arrival */}
                                                                                    <div className="col-md-4 offset-1">
                                                                                        <div className="timer">
                                                                                            <h4>{formatTime(last.arrivalDateTime)}</h4>
                                                                                            <p>{last.arrivalAirportCode}</p>
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                    {/* RIGHT */}
                                                                    <div className="col-md-4">
                                                                        <div className="price_view">
                                                                            <div
                                                                                className="flight_char"

                                                                            >
                                                                                <i className="fa fa-plane"></i> {label}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        );
                                    })()}
                                </div>
                            </>
                        )}

                    {approvalDetails && approvalDetails?.airBookingResponse?.[0] && approvalDetails?.airBookingResponse?.[0]?.customerInfo && approvalDetails?.airBookingResponse?.[0]?.customerInfo?.passengerDetails?.length > 0 && (
                        <>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <h4 className='headings'>Passenger Details</h4>
                                </div>
                                {approvalDetails && approvalDetails.airBookingResponse[0] && approvalDetails.airBookingResponse[0].customerInfo && approvalDetails.airBookingResponse[0].customerInfo.passengerDetails.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <div className='col-md-12'>
                                            <div class="d-flex mb-3">
                                                <div class="labl">Passenger Name </div>
                                                <div class="labl_detls">{item?.title} {item?.firstName} {item?.lastName}</div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ))}
                            </div>
                        </>
                    )}


                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="headings">Approvals</h4>
                        </div>

                        {/* ================= REQUEST ================= */}
                        <div className="col-md-12">
                            <div className="d-flex mb-3">
                                <div className="labl">Requested By</div>
                                <div className="labl_detls">
                                    {approval?.userId || "-"}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Submitted On</div>
                                <div className="labl_detls">
                                    {formatDateTime(approval?.createdOn)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Remark</div>
                                <div className="labl_detls">
                                    {approval?.remark || "-"}
                                </div>
                            </div>
                        </div>


                        {/* ================= LEVEL 1 ================= */}
                        <div className="col-md-12 mt-3">
                            <div className="d-flex align-items-center justify-content-between">
                                <h5 className="mb-3">
                                    <span className="badge bg-secondary me-2">LEVEL 1</span>
                                    First Level Approval
                                </h5>

                                {/* <span
                className={`badge ${approval?.level1ApprovalStatus === "Accepted"
                  ? "bg-warning text-dark"
                  : approval?.level1ApprovalStatus === "Rejected"
                    ? "bg-danger"
                    : "bg-warning text-dark"
                  }`}
              >
                {approval?.level1ApprovalStatus || "Requested"}
              </span> */}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Approver(s)</div>
                                <div className="labl_detls">
                                    <span className="badge bg-light text-dark border">
                                        {approval?.level1ApproverName || "-"}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Action By</div>
                                <div className="labl_detls">
                                    {approval?.level1ActionBy || "-"}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Action On</div>
                                <div className="labl_detls">
                                    {formatDateTime(approval?.level1ActionOn)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Status</div>
                                <div className="labl_detls">
                                    <span className="badge bg-warning text-dark">
                                        {approval?.level1ApprovalStatus || "Requested"}
                                    </span>
                                </div>
                            </div>
                        </div>


                        {/* ================= LEVEL 2 ================= */}
                        {approval?.level2ApproverName?.trim() && (
                            <>
                                <div className="col-md-12 mt-3">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h5 className="mb-3">
                                            <span className="badge bg-secondary me-2">LEVEL 2</span>
                                            Second Level Approval
                                        </h5>

                                        {/* <span className="badge bg-warning text-dark">
                {approval?.level2ApprovalStatus || "Requested"}
              </span> */}
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex mb-3">
                                        <div className="labl">Approver(s)</div>
                                        <div className="labl_detls">
                                            {approval?.level2ApproverName ? (
                                                <span className="badge bg-light text-dark border">
                                                    {approval.level2ApproverName}
                                                </span>
                                            ) : (
                                                "-"
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex mb-3">
                                        <div className="labl">Action By</div>
                                        <div className="labl_detls">
                                            {approval?.level2ActionBy || "-"}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex mb-3">
                                        <div className="labl">Action On</div>
                                        <div className="labl_detls">
                                            {formatDateTime(approval?.level2ActionOn)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex mb-3">
                                        <div className="labl">Status</div>
                                        <div className="labl_detls">
                                            <span className="badge bg-warning text-dark">
                                                {approval?.level2ApprovalStatus || "Requested"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    <div className='row'>
                        {/* {(
                            approvalDetails?.requestedApprovals?.[0]?.level1ApprovalStatus === "Requested" ||
                            (
                                approvalDetails?.requestedApprovals?.[0]?.level1ApprovalStatus === "Accepted" && approvalDetails?.requestedApprovals?.[0]?.level2ApprovalStatus === "Requested"
                            )
                        ) && (
                                <div className="col-md-12 text-end mt-10 mb-3">
                                    <button
                                        className="btn btn-primary m-1"
                                        onClick={() =>
                                            SubmitAcceptApprovalRequest(
                                                approvalDetails?.requestedApprovals?.[0]
                                            )
                                        }
                                    >
                                        Approve
                                    </button>
                                    <button className='btn btn-primary m-1' data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => setSelectedItem(approvalDetails?.requestedApprovals?.[0])}>Reject</button>
                                </div>
                            )} */}

                        {(() => {
                            const approval = approvalDetails?.requestedApprovals?.[0];
                            const approvalLevel = getUserApprovalLevel(approval, userName);

                            const currentStatus =
                                approvalLevel === 1
                                    ? approval?.level1ApprovalStatus
                                    : approvalLevel === 2
                                        ? approval?.level2ApprovalStatus
                                        : null;

                            return currentStatus === "Requested" && (
                                <div className="col-md-12 text-end mt-10 mb-3">
                                    <button
                                        type="button"
                                        className="btn btn-primary m-1"
                                        onClick={() => SubmitAcceptApprovalRequest(approval)}
                                    >
                                        Approve
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-primary m-1"
                                        data-bs-toggle="modal"
                                        data-bs-target="#myModal"
                                        onClick={() => setSelectedItem(approval)}
                                    >
                                        Reject
                                    </button>
                                </div>
                            );
                        })()}
                    </div>
                </div>
            </section>

            <div class="modal fade" id="myModal">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Cancel Request</h4>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        <div class="modal-body">
                            <div className='col-md-12'>
                                <label>Why Cancel ?</label>
                                <textarea className='form-controls' placeholder='Write Reason..' cols={80} rows={4}
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                ></textarea>
                            </div>
                            <div className='col-md-12 text-end'>
                                <button
                                    className="btn btn-danger"
                                    onClick={() =>
                                        SubmitRejectApprovalRequest(selectedItem)
                                    }
                                >
                                    Submit Request
                                </button>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}

export default FlightApprovalDetail